<template>
    <v-card elevation="0">
        <v-card-text class="pt-6">
            <v-form>
                <v-row dense>
                    <v-card elevation="0" class="px-2 mx-1" style="width: 100%">
                        <v-row>
                            <v-col cols="12" :md="!isComercialCobOrRec && hasClientsPermission ? 6 : 12" :class="$vuetify.breakpoint.smAndDown ? '' : 'd-flex'">
                                <v-autocomplete v-model="form.estadoOferta" :items="
                                    opciones ? opciones.oferta.estado : []
                                " label="Estado oferta" :dense="false" multiple clearable autocomplete="new"
                                    deletable-chips :small-chips="
                                        form.estadoOferta
                                            ? form.estadoOferta.length >= 1
                                            : false
                                    " item-text="human" item-value="encoded" prepend-icon="mdi-state-machine"
                                    @change="onChangeEstadoOfertaCombobox" :return-object="false">
                                    <template v-slot:selection="{ index, item }">
                                        <v-chip close @click:close="
                                            deleteEstadoOfertaComboBox(item)
                                        ">
                                            {{
                                            opciones.oferta.estado.find(
                                            (encoded) => encoded == item
                                            ).human
                                            }}
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="3" v-if="!isComercialCobOrRec && hasClientsPermission">
                                <v-select v-model="form_comercial" :items="comerciales" label="Comercial" required
                                    clearable :menu-props="{ maxHeight: '400' }" prepend-icon="mdi-account-tie"
                                    @blur="$v.form.comercial.$touch()" :error-messages="comercialErrores">
                                    <template #item="{ item }">
                                        <v-row style="width: 500px">
                                            <v-col :cols="
                                                $vuetify.breakpoint
                                                    .smAndDown
                                                    ? 10
                                                    : 9
                                            ">
                                                {{ item }}
                                            </v-col>
                                            <v-col v-if="
                                                getEstadoComercial(item) &&
                                                !$vuetify.breakpoint
                                                    .smAndDown
                                            " cols="3">
                                                <v-chip label :color="
                                                    estadoComercial[
                                                        getEstadoComercial(
                                                            item
                                                        )
                                                    ]
                                                " medium class="
                                                        d-flex
                                                        justify-center
                                                        overline
                                                    ">
                                                    {{
                                                    getEstadoComercial(item)
                                                    }}
                                                </v-chip>
                                            </v-col>
                                            <v-col v-if="
                                                getEstadoComercial(item) &&
                                                $vuetify.breakpoint
                                                    .smAndDown
                                            " cols="2">
                                                <v-icon :color="
                                                    estadoComercial[
                                                        getEstadoComercial(
                                                            item
                                                        )
                                                    ]
                                                " large class="
                                                        d-flex
                                                        justify-center
                                                        overline
                                                    ">
                                                    mdi-circle
                                                </v-icon>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="3" v-if="!isComercialCobOrRec && hasClientsPermission">
                                <v-select clearable prepend-icon="mdi-account-question" :items="['RECOMENDADOR']"
                                    label="Tipo comercial" v-model="form_tipo_comercial">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3" class="pt-0">
                                <v-menu v-model="bools.menu_fecha_contacto" :close-on-content-click="false"
                                    :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field clearable v-model="fecha_contacto" label="Fecha contacto"
                                            prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" :disabled="
                                                bools.fecha_contacto_isNull ===
                                                0
                                                    ? true
                                                    : false
                                            ">
                                            <template v-slot:prepend>
                                                <v-btn-toggle class="pa-0" style="
                                                        margin-top: -0px;
                                                        margin-left: 0px;
                                                    " v-model="
                                                        bools.fecha_contacto_isNull
                                                    " borderless>
                                                    <v-btn class="pa-0" small icon>
                                                        <v-icon>
                                                            {{
                                                            bools.fecha_contacto_isNull ===
                                                            0
                                                            ? 'mdi-calendar-remove'
                                                            : 'mdi-calendar'
                                                            }}
                                                        </v-icon>
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker range v-model="fecha_contacto_picker" locale="es-419"
                                        :first-day-of-week="1"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" md="3" class="pt-0">
                                <v-menu v-model="bools.menu_updated_on" :close-on-content-click="false"
                                    :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field clearable v-model="updated_on" label="Actualizado"
                                            prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" :disabled="
                                                bools.updated_on_isNull === 0
                                                    ? true
                                                    : false
                                            ">
                                            <template v-slot:prepend>
                                                <v-btn-toggle class="pa-0" style="
                                                        margin-top: -0px;
                                                        margin-left: 0px;
                                                    " v-model="
                                                        bools.updated_on_isNull
                                                    " borderless>
                                                    <v-btn class="pa-0" small icon>
                                                        <v-icon>
                                                            {{
                                                            bools.updated_on_isNull ===
                                                            0
                                                            ? 'mdi-calendar-remove'
                                                            : 'mdi-calendar'
                                                            }}
                                                        </v-icon>
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker range v-model="updated_on_picker" locale="es-419"
                                        :first-day-of-week="1"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" md="3" class="pt-0">
                                <v-menu v-model="bools.menu_fecha_agendado" :close-on-content-click="false"
                                    :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field clearable v-model="fecha_agendado" label="Fecha agendado"
                                            prepend-icon="mdi-calendar" readonly :disabled="
                                                bools.fecha_agendado_isNull ===
                                                0
                                                    ? true
                                                    : false
                                            " v-bind="attrs" v-on="on">
                                            <template v-slot:prepend>
                                                <v-btn-toggle class="pa-0" style="
                                                        margin-top: -0px;
                                                        margin-left: 0px;
                                                    " v-model="
                                                        bools.fecha_agendado_isNull
                                                    " borderless>
                                                    <v-btn class="pa-0" small icon>
                                                        <v-icon>
                                                            {{
                                                            bools.fecha_agendado_isNull ===
                                                            0
                                                            ? 'mdi-calendar-remove'
                                                            : 'mdi-calendar'
                                                            }}
                                                        </v-icon>
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker range v-model="fecha_agendado_picker"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" md="3" class="pt-0">
                                <v-menu v-model="bools.menu_fecha_venta" :close-on-content-click="false"
                                    :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field clearable v-model="fecha_venta" label="Fecha venta"
                                            prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" :disabled="
                                                bools.fecha_venta_isNull === 0
                                                    ? true
                                                    : false
                                            ">
                                            <template v-slot:prepend>
                                                <v-btn-toggle class="pa-0" style="
                                                        margin-top: -0px;
                                                        margin-left: 0px;
                                                    " v-model="
                                                        bools.fecha_venta_isNull
                                                    " borderless>
                                                    <v-btn class="pa-0" small icon>
                                                        <v-icon>
                                                            {{
                                                            bools.fecha_venta_isNull ===
                                                            0
                                                            ? 'mdi-calendar-remove'
                                                            : 'mdi-calendar'
                                                            }}
                                                        </v-icon>
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker range v-model="fecha_venta_picker"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-row>

                <v-row no-gutters class="mt-3">
                    <v-col cols="12">
                        <v-card elevation="0" class="px-2">
                            <v-row>
                                <v-col md="6" cols="12">
                                    <!-- :filter="OfferComboBoxFilter" -->
                                    <!-- @change="onChangeOfertaCombobox"> -->
                                    <v-combobox v-model="form.tipoOferta" :items="tipoObjetivo" label="Tipo de oferta"
                                        :chips="
                                            form.tipoOferta
                                                ? form.tipoOferta.length >= 1
                                                : false
                                        " :dense="false" multiple clearable deletable-chips autocomplete="new"
                                        :small-chips="
                                            form.tipoOferta
                                                ? form.tipoOferta.length >= 1
                                                : false
                                        " prepend-icon="mdi-shopping">
                                        <template v-slot:item="{ index, item }">
                                            <!-- <v-divider/> -->
                                            <v-list-item>
                                                <!-- <v-spacer/>
                                            <v-switch
                                                color="error"
                                            ></v-switch> -->
                                                {{ item.nombre }}
                                                <v-spacer />
                                                <v-btn :outlined="
                                                    form.tipoOferta.some(
                                                        (el) =>
                                                            el.includes(
                                                                item.id
                                                            ) &&
                                                            el.replace(
                                                                item.id +
                                                                    ':',
                                                                ''
                                                            ) == 't'
                                                    )" icon color="success" class="mr-1" @click.stop="
                                                        addOfertaComboBox(
                                                            item,
                                                            false
                                                        )">
                                                    <v-icon> mdi-check </v-icon>
                                                </v-btn>
                                                <v-btn :outlined="
                                                    form.tipoOferta.some(
                                                        (el) =>
                                                            el.includes(
                                                                item.id
                                                            ) &&
                                                            el.replace(
                                                                item.id +
                                                                    ':',
                                                                ''
                                                            ) == 'f'
                                                    )" icon color="error" class="mr-4" @click.stop="
                                                        addOfertaComboBox(
                                                            item,
                                                            true
                                                        )">
                                                    <v-icon> mdi-close </v-icon>
                                                </v-btn>
                                            </v-list-item>
                                        </template>
                                        <template v-slot:selection="{ index, item }">
                                            <v-chip close outlined @click:close="
                                                deleteOfertaComboBox(item)" :color="
                                                    item.slice(-1) == 't'
                                                        ? 'success'
                                                        : 'error'">
                                                <v-icon left>
                                                    {{
                                                    item.slice(-1) == 't'
                                                    ? 'mdi-cart-plus'
                                                    : 'mdi-cart-remove'
                                                    }}
                                                </v-icon>
                                                {{
                                                tipoObjetivo.find((el) =>
                                                item.includes(el.id)
                                                ).nombre
                                                }}
                                            </v-chip>
                                        </template>
                                    </v-combobox>
                                </v-col>
                                <v-col md="6" cols="12">
                                    <v-autocomplete 
										clearable
                                        multiple
										hide-selected
										:items="administrations"
										item-text="name"
										item-value="id"
										v-model="form.tipoGestion"
										label="Tipo de Gestión"
                                        prepend-icon="mdi-toolbox-outline"
                                    >
                                        <template v-slot:selection="{ item }">
                                            <v-chip
                                                color="purple"
                                                outlined
                                                close
                                                @click:close="form.tipoGestion.splice(form.tipoGestion.indexOf(item), 1)"
                                            >   
                                                <v-icon left>mdi-tools</v-icon>
                                                <span>{{ item.name }}</span>
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row no-gutters dense class="mt-2">
                    <v-card elevation="0" class="px-2" style="width: 100%">
                        <v-row>
                            <v-col no-gutters dense cols="12" md="5">
                                <div class="d-flex flex-row justify-center align-center">
                                    <v-icon>
                                        mdi-cash-register
                                    </v-icon>
                                    <p class="overline mb-0 ml-2">Tramitada</p>
                                    <v-radio-group
                                        class="ml-4"
                                        :row="$vuetify.breakpoint.smAndDown ? false : true"
                                        v-model="form.processed"
                                        mandatory
                                    >
                                        <v-radio label="Todos" :value="null"></v-radio>
                                        <v-radio label="Sí" :value="true"></v-radio>
                                        <v-radio label="No" :value="false"></v-radio>
                                    </v-radio-group>
                                </div>
                            </v-col>
                            <v-col no-gutters dense cols="12" md="3">
                                <v-select v-model="form.opciones_tipo_llamada" :items="opcionesTipoLlamada"
                                    label="Estado llamada" item-text="human" item-value="encoded" required single-line
                                    clearable @change="deleteReason()" prepend-icon="mdi-state-machine"></v-select>
                            </v-col>
                            <v-col no-gutters dense cols="12" md="4">
                                <v-select :disabled="
                                    form.opciones_tipo_llamada == null ||
                                    form.opciones_tipo_llamada == 'NC'
                                " v-model="form.opciones_no_interesado" :items="opcionesNoInteresado"
                                    label="Razón no interesado" item-text="human" item-value="encoded" required
                                    single-line :hint="
                                        form.opciones_tipo_llamada != 'NI'
                                            ? 'Seleccione No Interesado'
                                            : ''
                                    " persistent-hint clearable prepend-icon="mdi-state-machine"></v-select>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import { email, maxLength, minLength } from 'vuelidate/lib/validators';
import { valid_nif, valid_nie, valid_cif } from '@/validators';

import { ofertaTipo, documentoTipo } from '@/util/optionsTtForm.json';
import {
    nombreErrores,
    documentoErrores,
    telf_fijoErrores,
    telf_movilErrores,
    telefonoErrores,
    emailErrores,
    direccionErrores,
    cpErrores,
    localidadErrores,
    origenBbddErrores,
    segmentoErrores,
    comercialErrores,
    ispErrores,
    estadoErrores,
    ofertaErrores,
} from './errorHandlers';

import { defaultTtForm } from '@/util/defaultTtForm';

import {
    swapKeysAndValues,
    objectCamelToSnakeCase,
    clone,
} from '@/util/libUtil.js';

let local_defaultTtForm = JSON.parse(JSON.stringify(defaultTtForm));
local_defaultTtForm.fecha_contacto = [];
local_defaultTtForm.updated_on = [];
local_defaultTtForm.fecha_agendado = [];
local_defaultTtForm.fecha_venta = [];
local_defaultTtForm.tipo_document = null;

import { mapState, mapGetters } from 'vuex';

export default {
    name: 'AttentionDataFilters',

    data: () => ({
        //         form: JSON.parse(JSON.stringify(local_defaultTtForm)),
        estadoComercial: {
            ALTA: 'success',
            BAJA: 'warning',
            INACTIVO: 'error',
            VACACIONES: 'blue',
        },
        comercial_nombre: '',
        bools: {
            fecha_contacto: false,
            updated_on: false,
            fecha_agendado: false,
            fecha_venta: false,
            fecha_contacto_isNull: false,
            updated_on_isNull: false,
            fecha_agendado_isNull: false,
            fecha_venta_isNull: false,
            menu_telf: false,
        },
        last_fecha_contacto: [],
        last_updated_on: [],
        last_fecha_agendado: [],
        last_fecha_venta: [],
        documentoTipo,
        // segmentoTipo,
        comerciales: [],
        // ispTipo,
        // estadoTipo,
        ofertaTipo,
        dialog: true,
        uploading_form: false,
        OfferComboBoxFilter: function (item, queryText, itemText) {
            itemText = item.name;
            // console.log(this.offerTipo)
            // queryText = Array.from()
            return (
                itemText
                    .toLocaleLowerCase()
                    .indexOf(queryText.toLocaleLowerCase()) > -1
            );
        },
    }),
    validations() {
        let valid_document = true;
        let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;
        let validTelefono = () => {
            if (!this.form.telefono) {
                return true;
            }

            return regexTelefono.test(this.form.telefono);
        };

        let form = {
            nombre: {
                required: false,
                max: maxLength(25),
            },
            documento: {
                required: false,
                max: maxLength(30),
                valid_document,
            },
            telefono: {
                validTelefono,
            },
            email: {
                email,
            },
            cp: {
                required: false,
                max: maxLength(5),
                min: minLength(5),
            },
            localidad: {
                required: false,
            },
            fecha_contacto: {
                required: false,
            },
            updated_on: {
                required: false,
            },
            orig_bbdd: {
                required: false,
            },
            segmento: {
                required: false,
            },
            comercial: {
                required: false,
            },
            isp: {
                required: false,
            },
            estado: {
                required: false,
            },
            oferta: {
                required: false,
            },
        };
        return {
            form,
        };
    },
    computed: {
        nombreErrores,
        documentoErrores,
        telf_fijoErrores,
        telf_movilErrores,
        emailErrores,
        direccionErrores,
        cpErrores,
        localidadErrores,
        origenBbddErrores,
        segmentoErrores,
        comercialErrores,
        ispErrores,
        estadoErrores,
        ofertaErrores,
        telefonoErrores,
        telf_label() {
            return (
                this.form.telf_movil +
                (this.form.telf_movil && this.form.telf_fijo ? '-' : '') +
                this.form.telf_fijo
            );
        },
        cp() {
            return this.form.cp;
        },
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
        opcionesCuenta() {
            return JSON.parse(localStorage.getItem("opciones"))?.cuenta;
        },
        dialogState: {
            get: function () {
                return this.$store.state.teletrabajo.IsOpenTtQueryDialog;
            },
            set: function (val) {
                this.$store.dispatch('teletrabajo/closeTtQueryDialog', val);
            },
        },
        form_comercial: {
            set: function (val) {
                this.form.comercial = val
                    ? this.comerciales_dict.filter(
                          (el) => el.nombreCompleto == val
                      )[0].id
                    : null;
                if (!this.form.comercial) {
                    this.form.comercial = null;
                }
                // console.log(this.form.comercial)
            },
            get: function () {
                return this.form.comercial?.nombreCompleto;
            },
        },
        form_tipo_comercial: {
            set: function (val) {
                this.form.tipo_comercial = val
            },
            get: function () {
                return this.form.tipo_comercial
            },
        },
        fecha_contacto: {
            get: function () {
                if (this.bools.fecha_contacto_isNull === 0)
                    return 'Sin fecha de contacto';

                if (
                    !this.form.fecha_contacto[0] ||
                    this.form.fecha_contacto === 'null'
                )
                    return '';
                const [year, month, day] =
                    this.form.fecha_contacto[0].split('-');
                if (!this.form.fecha_contacto[1])
                    return `${day}/${month}/${year}`;

                const [year2, month2, day2] =
                    this.form.fecha_contacto[1].split('-');
                return (
                    `${day}/${month}/${year}` +
                    ' ~ ' +
                    `${day2}/${month2}/${year2}`
                );
            },
            set: function (val) {
                if (!val) {
                    val = [];
                }
                this.form.fecha_contacto = val;
            },
        },
        updated_on: {
            get: function () {
                if (this.bools.updated_on_isNull === 0)
                    return 'Sin fecha de contacto';

                if (!this.form.updated_on[0] || this.form.updated_on === 'null')
                    return '';
                const [year, month, day] = this.form.updated_on[0].split('-');
                if (!this.form.updated_on[1]) return `${day}/${month}/${year}`;

                const [year2, month2, day2] =
                    this.form.updated_on[1].split('-');
                return (
                    `${day}/${month}/${year}` +
                    ' ~ ' +
                    `${day2}/${month2}/${year2}`
                );
            },
            set: function (val) {
                if (!val) {
                    val = [];
                }
                this.form.updated_on = val;
            },
        },
        fecha_agendado: {
            get: function () {
                if (this.bools.fecha_agendado_isNull === 0)
                    return 'Sin fecha de agendado';

                if (
                    !this.form.fecha_agendado[0] ||
                    this.form.fecha_agendado === 'null'
                )
                    return '';
                const [year, month, day] =
                    this.form.fecha_agendado[0].split('-');
                if (!this.form.fecha_agendado[1])
                    return `${day}/${month}/${year}`;
                const [year2, month2, day2] =
                    this.form.fecha_agendado[1].split('-');
                return (
                    `${day}/${month}/${year}` +
                    ' ~ ' +
                    `${day2}/${month2}/${year2}`
                );
            },
            set: function (val) {
                if (!val) {
                    val = [];
                }
                this.form.fecha_agendado = val;
            },
        },
        fecha_venta: {
            get: function () {
                // console.log(this.form.fecha_venta)
                if (this.bools.fecha_venta_isNull === 0)
                    return 'Sin fecha de venta';

                if (
                    !this.form.fecha_venta[0] ||
                    this.form.fecha_venta === 'null'
                )
                    return '';
                const [year, month, day] = this.form.fecha_venta[0].split('-');
                if (!this.form.fecha_venta[1]) return `${day}/${month}/${year}`;
                const [year2, month2, day2] =
                    this.form.fecha_venta[1].split('-');
                return (
                    `${day}/${month}/${year}` +
                    ' ~ ' +
                    `${day2}/${month2}/${year2}`
                ); // return ''
            },
            set: function (val) {
                if (!val) {
                    val = [];
                }
                this.form.fecha_venta = val;
            },
        },
        isp: {
            get() {
                return this.decodeIsp[this.form.ispActual];
            },
            set(val) {
                this.form.ispActual = this.encodeIsp[val];
            },
        },
        fecha_contacto_picker: {
            get: function () {
                if (this.form.fecha_contacto === 'null') return [];
                return this.form.fecha_contacto;
            },
            set(val) {
                this.fecha_contacto = val;
            },
        },
        updated_on_picker: {
            get: function () {
                if (this.form.updated_on === 'null') return [];
                return this.form.updated_on;
            },
            set(val) {
                this.updated_on = val;
            },
        },
        fecha_venta_picker: {
            get() {
                if (this.form.fecha_venta === 'null') return [];
                return this.form.fecha_venta;
            },
            set(val) {
                this.fecha_venta = val;
            },
        },
        fecha_agendado_picker: {
            get() {
                if (this.form.fecha_agendado === 'null') return [];
                return this.form.fecha_agendado;
            },
            set(val) {
                this.fecha_agendado = val;
            },
        },
        tipoObjetivo() {
            return this.opciones.tipoObjetivo;
        },
        fecha_agendado_isNull() {
            return this.bools.fecha_agendado_isNull;
        },
        fecha_contacto_isNull() {
            return this.bools.fecha_contacto_isNull;
        },
        updated_on_isNull() {
            return this.bools.updated_on_isNull;
        },
        fecha_venta_isNull() {
            return this.bools.fecha_venta_isNull;
        },
        form: {
            get: function () {
                return this.$store.state.teletrabajo.QueryForm;
            },
            set: function (val) {
                this.$store.commit('teletrabajo/QueryForm', val);
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        origenBbddTipo() {
            return JSON.parse(localStorage.getItem('origenesBbdd'));
        },
        opcionesTipoLlamada() {
            return this.opciones.noInteresado.tipo;
        },
        opcionesNoInteresado() {
            return this.opciones.noInteresado.razon;
        },
        ...mapState('teletrabajo', {
            administrations: (state) => state.administrations,
        }),
        ...mapState('util', {
            encodeIsp: (state) =>
                state.opciones
                    ? swapKeysAndValues(state.opciones.cliente.isp)
                    : {},
            decodeIsp: (state) =>
                state.opciones ? state.opciones.cliente.isp : {},
        }),
        ...mapGetters('teletrabajo', {
            comerciales_dict: 'allComerciales',
        }),
        ...mapGetters('login', {
            isComercialCobOrRec: 'isComercialCobOrRec',
            hasClientsPermission: 'hasClientsPermission',
        })
    },
    methods: {
        deleteReason() {
            this.form.opciones_no_interesado = 'NI'
                ? (this.form.opciones_no_interesado = [])
                : '';
        },
        getEstadoComercial(nombre) {
            return this.comerciales_dict.filter(
                (comercial) => comercial.nombreCompleto == nombre
            )[0].estado;
        },
        close() {
            this.$v.$reset();
            this.$store.dispatch('teletrabajo/closeTtQueryDialog');
            //this.clear();
        },
        async clearform() {
            await this.$store.dispatch('teletrabajo/setDefaultQueryForm');
            let monParams = objectCamelToSnakeCase(this.form);

            // encodeQuery(monParams)
            monParams.page = 1;
            this.uploading_form = true;
            this.$store.dispatch('teletrabajo/updateQueryParams', monParams);
            this.bools = {
                fecha_contacto: false,
                updated_on: false,
                fecha_agendado: false,
                fecha_venta: false,
                fecha_contacto_isNull: false,
                updated_on_isNull: false,
                fecha_agendado_isNull: false,
                fecha_venta_isNull: false,
                menu_telf: false,
            };
            this.last_fecha_contacto = [];
            this.last_updted_on = [];
            this.last_fecha_agendado = [];
            this.last_fecha_venta = [];
            this.$store
                .dispatch('teletrabajo/getTableData')
                .then(() => {
                    this.uploading_form = false;
                })
                .catch(() => {
                    this.uploading_form = false;
                });
            this.uploading_form = true;
        },
        addOfertaComboBox(tipoObjetivo, hasProduct) {
            let isContained = this.form.tipoOferta.some((el) =>
                el.includes(tipoObjetivo.id)
            );
            if (!isContained) {
                this.form.tipoOferta.push(
                    tipoObjetivo.id + ':' + (hasProduct ? 'f' : 't')
                );
            } else {
                let index = this.form.tipoOferta.findIndex((el) =>
                    el.includes(tipoObjetivo.id)
                );
                if (
                    this.form.tipoOferta[index].replace(
                        tipoObjetivo.id + ':',
                        ''
                    ) == (hasProduct ? 'f' : 't')
                ) {
                    this.deleteOfertaComboBox(tipoObjetivo);
                } else {
                    this.form.tipoOferta[index] =
                        tipoObjetivo.id + ':' + (hasProduct ? 'f' : 't');
                    this.form.tipoOferta = clone(this.form.tipoOferta); // Juan y antonio lo sienten, es que sin el clone no cambia la referencia y vue no se entera. <3, Mamá.
                }
            }
        },
        deleteOfertaComboBox(tipoObjetivo) {
            if (typeof tipoObjetivo == 'string') {
                tipoObjetivo = this.tipoObjetivo.find(({ id }) =>
                    tipoObjetivo.includes(id)
                );
                if (!tipoObjetivo) console.log('que hisiste puto');
            }

            let isContained = this.form.tipoOferta.some((el) =>
                el.includes(tipoObjetivo.id)
            );
            if (isContained) {
                let index = this.form.tipoOferta.findIndex((el) =>
                    el.includes(tipoObjetivo.id)
                );
                this.form.tipoOferta.splice(index, 1);
            }
        },
        orderDates(arr) {
            let date_from = new Date(arr[0]);
            let date_to = new Date(arr[1]);
            if (date_from > date_to) {
                let c = arr[0];
                arr[0] = arr[1];
                arr[1] = c;
            }
            return arr;
        },
        onChangeEstadoOfertaCombobox(items) {
            if (!this.opciones) return;

            for (let i = 0; i < items.length; i++) {
                let isValid = this.opciones.oferta.estado.some(
                    ({ encoded }) => encoded === items[i]
                );
                if (!isValid) this.form.estadoOferta.splice(i, 1);
            }
        },
        deleteEstadoOfertaComboBox(item) {
            this.form.estadoOferta.splice(
                this.form.estadoOferta.indexOf(item),
                1
            );
        },
    },
    watch: {
        comerciales_dict: {
            immediate: true,
            handler: function () {
                this.comerciales = this.comerciales_dict.map(
                    ({ nombreCompleto }) => nombreCompleto
                );
            },
        },
        fecha_agendado_isNull() {
            if (this.bools.fecha_agendado_isNull == 0) {
                this.last_fecha_agendado = this.form.fecha_agendado;
                this.form.fecha_agendado = 'null';
            } else {
                this.form.fecha_agendado = this.last_fecha_agendado;
            }
        },
        fecha_contacto_isNull() {
            if (this.bools.fecha_contacto_isNull == 0) {
                this.last_fecha_contacto = this.form.fecha_contacto;
                this.form.fecha_contacto = 'null';
            } else {
                this.form.fecha_contacto = this.last_fecha_contacto;
            }
        },
        updated_on_isNull() {
            if (this.bools.updated_on_isNull == 0) {
                this.last_updated_on = this.form.updated_on;
                this.form.updated_on = 'null';
            } else {
                this.form.updated_on = this.last_updated_on;
            }
        },
        fecha_venta_isNull() {
            if (this.bools.fecha_venta_isNull == 0) {
                this.last_fecha_venta = this.form.fecha_venta;
                this.form.fecha_venta = 'null';
            } else {
                this.form.fecha_venta = this.last_fecha_venta;
            }
        },
        form: {
            deep: true,
            immediate: true,
            handler: function () {
                if (this.form.fecha_contacto[1]) {
                    this.form.fecha_contacto = this.orderDates(
                        this.form.fecha_contacto
                    );
                }
                if (this.form.updated_on[1]) {
                    this.form.updated_on = this.orderDates(
                        this.form.updated_on
                    );
                }
                if (this.form.fecha_agendado[1]) {
                    this.form.fecha_agendado = this.orderDates(
                        this.form.fecha_agendado
                    );
                }
                if (this.form.fecha_venta[1]) {
                    this.form.fecha_venta = this.orderDates(
                        this.form.fecha_venta
                    );
                }
                if (
                    this.form.opciones_tipo_llamada &&
                    this.form.opciones_tipo_llamada == 'NC'
                ) {
                    if (this.form.opciones_no_interesado) {
                        this.form.opciones_no_interesado = null;
                    }
                }
            },
        },
    },
    updated() {
        let filters = 0;
        let fields = [
            'estadoOferta',
            'tipoOferta',
            'tipoGestion',
            'opciones_tipo_llamada',
            'opciones_no_interesado',
            'comercial',
            'fecha_contacto',
            'updated_on',
            'fecha_agendado',
            'fecha_venta',
            'processed',
        ];

        Object.keys(this.form).forEach((field) => {
            if (
                fields.includes(field) &&
                this.form[field] !== null &&
                this.form[field] !== '' &&
                (this.form[field]?.length || typeof this.form[field] === 'boolean')
            )
                filters += 1;
        });

        this.$root.$emit('attentionFilters', filters);
    },
    mounted() {
        this.$root.$on('deleteTableFilters', () => {
            this.clearform();
        });

		if (this.$store.state.teletrabajo.administrations.length == 0) {
			this.$store.dispatch('teletrabajo/getAdministrations');
        }
        
        if (!this.comerciales.length) {
            this.$store.dispatch('teletrabajo/fetchComerciales');
            this.$store.dispatch('util/fetchTipoObjetivo');
        }
        if (this.form.comercial) {
            this.form_comercial = this.form.comercial.nombre;
        }
    },
};
</script>
<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
}
</style>